/**
 * Barre d'achat permanente — mode « toujours visible » du bloc
 * _product-add-to-cart-button.liquid.
 *
 * Le bouton de la barre n'est pas un bouton de formulaire : il relaie le clic
 * vers le vrai bouton d'ajout au panier resté dans la fiche. Deux boutons submit
 * dans le même formulaire se disputeraient l'état de chargement géré par
 * product-form.js, et le sélecteur de formule doit rester le seul point d'entrée.
 *
 * La barre reflète en continu l'état du vrai bouton : prix, libellé, indisponibilité.
 */
(function () {
  'use strict';

  if (window.__zoemassBuybar) return;
  window.__zoemassBuybar = true;

  function realButton() {
    return document.querySelector('product-form [data-ref="add-to-cart-button"]');
  }

  function container() {
    return document.querySelector('product-form [data-ref="add-to-cart-button-container"]');
  }

  function money(el, cents) {
    var currency = (el && el.dataset.currency) || 'EUR';
    var locale = (el && el.dataset.locale) || 'fr';
    try {
      var whole = cents % 100 === 0;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  /** Réserve la hauteur de la barre pour que le pied de page reste atteignable. */
  /**
   * Aligne le résumé sur le coloris choisi : vignette et valeur des cadeaux.
   *
   * Les deux sont rendus pour toutes les variantes dans le bloc, puis désignés
   * ici. Sans cette permutation, la barre affiche la photo et les accessoires de
   * la variante par défaut quel que soit le coloris sélectionné.
   */
  function syncVariant(bar, id) {
    bar.querySelectorAll('[data-zsum]').forEach(function (summary) {
      var thumbs;
      var gifts;

      try {
        thumbs = JSON.parse(summary.dataset.thumbMap || '{}');
        gifts = JSON.parse(summary.dataset.giftsMap || '{}');
      } catch (error) {
        return;
      }

      var img = summary.querySelector('[data-zsum-thumb]');
      if (img && thumbs[id] && img.getAttribute('src') !== thumbs[id]) {
        img.src = thumbs[id];
      }

      var value = summary.querySelector('[data-zsum-gifts]');
      if (value && Object.prototype.hasOwnProperty.call(gifts, id)) {
        var row = value.closest('.zsum__gifts');
        if (gifts[id] > 0) {
          // Devise et langue vivent sur le bloc prix, pas sur cette ligne.
          value.textContent = money(summary.querySelector('.zsum__price') || value, gifts[id]);
          if (row) row.hidden = false;
        } else if (row) {
          row.hidden = true;
        }
      }
    });
  }

  function reserveSpace(bar) {
    var height = bar.offsetHeight;
    if (height) document.body.style.paddingBottom = height + 'px';
  }

  /**
   * Total annoncé par une offre à paliers, s'il y en a une sur la page.
   * Prioritaire sur le prix de la variante : c'est ce que le client va payer.
   */
  var offer = null;

  function sync(bar) {
    var source = container();
    var button = realButton();
    var proxy = bar.querySelector('[data-zbuybar-submit]');
    if (!proxy) return;

    if (button) proxy.disabled = button.disabled;

    var priceEl = bar.querySelector('.zsum__price');
    var btnPrice = bar.querySelector('[data-zbuybar-price]');
    if (!source && !offer) return;

    var cents = offer ? offer.price : parseInt(source.dataset.price, 10);
    if (isNaN(cents)) return;

    var compare = offer
      ? offer.compareAtPrice
      : parseInt(source.dataset.compareAtPrice, 10);
    if (compare === null) compare = NaN;

    if (priceEl) {
      var markup = money(priceEl, cents);
      if (!isNaN(compare) && compare > cents) {
        markup += ' <s>' + money(priceEl, compare) + '</s>';
      }
      priceEl.innerHTML = markup;
    }

    if (btnPrice) btnPrice.textContent = money(priceEl, cents);
  }

  /**
   * Deux boutons identiques à l'écran, c'est un de trop : la barre s'efface tant
   * que le vrai bouton est visible. Le conteneur est re-rendu à chaque changement
   * de variante, d'où la nouvelle observation après variant:updated.
   */
  function watchRealButton(bar) {
    if (!('IntersectionObserver' in window)) {
      bar.dataset.away = 'false';
      return;
    }
    var observed = null;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.dataset.away = entry.isIntersecting ? 'true' : 'false';
      });
    });
    function observe() {
      var target = container() || realButton();
      if (!target) {
        bar.dataset.away = 'false';
        return;
      }
      if (target === observed) return;
      if (observed) observer.unobserve(observed);
      observed = target;
      observer.observe(target);
    }
    observe();
    document.addEventListener('variant:updated', function () {
      window.requestAnimationFrame(observe);
    });
  }

  function init() {
    var bar = document.querySelector('zoemass-buybar');
    if (!bar) return;

    var proxy = bar.querySelector('[data-zbuybar-submit]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        var button = realButton();
        if (!button || button.disabled) return;
        button.click();
      });
    }

    sync(bar);
    reserveSpace(bar);
    bar.dataset.ready = 'true';
    watchRealButton(bar);

    document.addEventListener('variant:updated', function (event) {
      var variant = event.detail && event.detail.resource;
      window.requestAnimationFrame(function () {
        if (variant && variant.id) syncVariant(bar, variant.id);
        sync(bar);
        reserveSpace(bar);
      });
    });

    // Émis par product-offer-tiers.js quand la formule change.
    document.addEventListener('zoemass:offer-updated', function (event) {
      offer = event.detail;
      sync(bar);
      reserveSpace(bar);
    });

    // Le bloc d'offre s'initialise avant cette barre et a donc déjà émis son
    // premier événement : on lui en redemande un pour ne pas rater le total.
    document.dispatchEvent(new CustomEvent('zoemass:offer-request'));

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        reserveSpace(bar);
      }).observe(bar);
    } else {
      window.addEventListener('resize', function () {
        reserveSpace(bar);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
